import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Customer } from '../models/combined-interfaces.model';
import { AdminCommonHttpService } from '../service/admin-common-http.service';
import { CommonModule, DatePipe } from '@angular/common';


@Component({
  selector: 'app-manage-customer',
  standalone: true,
  imports: [DatePipe, CommonModule],
  templateUrl: './manage-customer.component.html',
  styleUrl: './manage-customer.component.css'
})
export class ManageCustomerComponent implements OnInit {

  customers: Customer[] = [];
  loading = false;
  error = '';

  constructor(private apiService: AdminCommonHttpService, private router: Router) { }

  async ngOnInit(): Promise<void> {
    await this.fetchCustomers();
  }

  async fetchCustomers(): Promise<void> {
    this.loading = true;
    this.customers = await this.apiService.getAllCustomers();
    this.loading = false;
  }

  viewCustomerOrders(customerId: string): void {
    this.router.navigate(['/admin/manage-orders'], { queryParams: { customer_id: customerId } });
  }
}
